import { TConfigurationState } from 'src/redux/configuration/configuration.slice';

export enum EChartEnergyBillsAndNetTradedType {
  Expanded = 'EXPANDED',
  Compact = 'COMPACT',
}

export type TChartEnergyBillsAndNetTradedProps = {
  priceEnergyAreaBalance:
    | NonNullable<TConfigurationState['simulationResults']>['priceEnergyAreaBalance']
    | undefined;
  type: EChartEnergyBillsAndNetTradedType;
};
